/**
 * get active slide id in specific image array by active image name
 * 
 * @param {Array} images
 * @param {String} imageName 
 * @returns Active slide Id
 */
export const getActiveSlideId = (images, imageName) => {
    const activeImage = images.find(img => {
        return img.file_name === imageName;
    });

    if (activeImage) {
        return images.indexOf(activeImage);
    }
    // no active slide
    return null;
}
/**
 * get count of slides that shown on specific window width
 * 
 * @param {object} settings 
 * @returns {Number} Slides count
 */
export const getSlidesToShow = (settings) => {
    const windowWidth = window.innerWidth;
    const setting = settings.responsive.find(settting => {
        return windowWidth < settting.breakpoint
    });
    if (!setting) {
        return settings.slidesToShow;
    }
    return setting.settings.slidesToShow;
}